import React, {useEffect, useState} from 'react'

const PortalContext = React.createContext({
    login: null,
    logout: null,
    isAdmin: null,
    id: null,
    name: null,
    email: null,
    role: null,
    profile: null,
    lastLoginDateTime: null
})

export const PortalContextProvider = (props) => {
    const storagePrefix = 'portal-stor-'

    // Local Storage
    const storedId = localStorage.getItem(`${storagePrefix}id`)
    const storedName = localStorage.getItem(`${storagePrefix}name`)
    const storedEmail = localStorage.getItem(`${storagePrefix}email`)
    const storedRole = localStorage.getItem(`${storagePrefix}role`)
    const storedProfile = localStorage.getItem(`${storagePrefix}profile`)
    const storedLastLoginDateTime = localStorage.getItem(`${storagePrefix}lastLoginDateTime`)

    // State
    const [id, setId] = useState(storedId)
    const [name, setName] = useState(storedName)
    const [email, setEmail] = useState(storedEmail)
    const [role, setRole] = useState(storedRole)
    const [profile, setProfile] = useState(storedProfile)
    const [lastLoginDateTime, setLastLoginDateTime] = useState(storedLastLoginDateTime)

    // Logout
    const logoutHandler = () => {
        localStorage.removeItem(`${storagePrefix}id`)
        localStorage.removeItem(`${storagePrefix}name`)
        localStorage.removeItem(`${storagePrefix}email`)
        localStorage.removeItem(`${storagePrefix}role`)
        localStorage.removeItem(`${storagePrefix}profile`)
        localStorage.removeItem(`${storagePrefix}lastLoginDateTime`)
        setId('')
        setName('')
        setEmail('')
        setRole('')
        setProfile('')
        setLastLoginDateTime(false)
    }

    // Login
    const loginHandler = (id, name, email, role, profile, lastLoginDateTime) => {
        localStorage.setItem(`${storagePrefix}id`, id)
        localStorage.setItem(`${storagePrefix}name`, name)
        localStorage.setItem(`${storagePrefix}email`, email)
        localStorage.setItem(`${storagePrefix}role`, role)
        localStorage.setItem(`${storagePrefix}profile`, profile)
        localStorage.setItem(`${storagePrefix}lastLoginDateTime`, lastLoginDateTime)
        setId(id)
        setName(name)
        setEmail(email)
        setRole(role)
        setProfile(profile)
        setLastLoginDateTime(lastLoginDateTime)
    }

    const isAdminRole = () => {
        return profile === 'Administrator'
    }

    const Auth = {
        id: id,
        name: name,
        email: email,
        role: role,
        profile: profile,
        lastLoginDateTime: lastLoginDateTime,
        login: loginHandler,
        logout: logoutHandler,
        isAdmin: isAdminRole
    }

    return (
        <PortalContext.Provider value={Auth}>
            {props.children}
        </PortalContext.Provider>
    )
}

export default PortalContext